import { render } from "./BalanceInquiryView.vue?vue&type=template&id=0468134a&scoped=true"
import script from "./BalanceInquiryView.vue?vue&type=script&lang=js"
export * from "./BalanceInquiryView.vue?vue&type=script&lang=js"

import "./BalanceInquiryView.vue?vue&type=style&index=0&id=0468134a&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0468134a"]])

export default __exports__